import { boolean, InferType, object, string } from "yup";

export type IFormularioMoozCartoesSchema = InferType<
  typeof formMoozCartoesSchema
>;

export const formMoozCartoesSchema = object({
  date: string().required(),
  empresa: string().required(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable(),
  tipoArquivo: string().required()
});
